import React from 'react';
import { connect } from 'react-redux';
import SettingsProfile from './SettingsProfile';
import SettingsMore from './SettingsMore';
import './Settings.css';

const Settings = () => (
  <div className="settings-root">
    <SettingsProfile />
    <SettingsMore />
  </div>
);

export default connect()(Settings);



// WEBPACK FOOTER //
// ./src/components/settings/Settings.js